module.exports = __webpack_public_path__ + "static/img_pledge_interview_07-26841002c6fabbc42f7d2c3c9868b198.png";